import axios from '../api/axios';
import useAxiosFunction from '../hooks/useAxiosFunction';
import {
    Card,
    Box
} from '@mui/material';

export default function AttachmentList({ files }) {

    const [response, error, loading, axiosFetch] = useAxiosFunction();

    if (!files || files.length === 0) {
        return null;
    }

    const openFile = async (file) => {

        try {

            const data = await axiosFetch({
                axiosInstance: axios,
                method: 'get',
                url: `/job-advert-file/${file.id}`,
                requestConfig: {
                    responseType: 'blob'
                }
            });

            const blob = data instanceof Blob ? data : new Blob([data]);
            const blobUrl = window.URL.createObjectURL(blob);

            window.open(blobUrl, "_blank");

        } catch (err) {
            console.log(err);
        }
    };

    return (

        <div>

            <h2 style={{ marginBottom: '20px' }}>
                Job Description and Person Specification
            </h2>

            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))',
                    gap: 2
                }}
            >

                {files.map(file => (

                    <Card
                        key={file.id}
                        sx={{
                            height: 220,
                            borderRadius: 2,
                            overflow: 'hidden',
                            position: 'relative',
                            boxShadow: 2
                        }}
                    >

                        {/* IMAGE PREVIEW */}
                        {file.fileType === "IMAGE" && (
                            <>
                                <Box
                                    sx={{
                                        height: '100%',
                                        width: '100%',
                                        backgroundImage: `url(${process.env.REACT_APP_API_URL}/job-advert-file/${file.id})`,
                                        backgroundSize: 'cover',
                                        backgroundPosition: 'center'
                                    }}
                                />

                                {/* click overlay */}
                                <Box
                                    onClick={() => openFile(file)}
                                    sx={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '100%',
                                        cursor: 'pointer'
                                    }}
                                />
                            </>
                        )}

                        {/* PDF PREVIEW */}
                        {file.fileType === "PDF" && (
                            <>
                                <iframe
                                    src={`${process.env.REACT_APP_API_URL}/job-advert-file/${file.id}`}
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        border: 'none'
                                    }}
                                    title={`pdf-preview-${file.id}`}
                                />

                                {/* click overlay */}
                                <Box
                                    onClick={() => openFile(file)}
                                    sx={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '100%',
                                        cursor: 'pointer',

                                        // invisible overlay background (important for readability on hover)
                                        backgroundColor: 'rgba(0,0,0,0.0)',

                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',

                                        '&:hover': {
                                            backgroundColor: 'rgba(0,0,0,0.35)',
                                        },

                                        transition: '0.2s ease'
                                    }}
                                >
                                    <Box
                                        sx={{
                                            color: 'white',
                                            fontSize: '14px',
                                            fontWeight: 500,
                                            opacity: 0,
                                            transition: '0.2s ease',

                                            // show text on hover of parent
                                            '.MuiBox-root:hover &': {
                                                opacity: 1
                                            }
                                        }}
                                    >
                                        Download PDF
                                    </Box>
                                </Box>
                            </>
                        )}

                    </Card>

                ))}

            </Box>

        </div>
    );
}